'use client';

import { forwardRef } from 'react';
import { RotatingLines } from 'react-loader-spinner';

import { LoadingButtonProps } from './loadingButton.props';
import { LoadingIndicatorBox, StyledButton } from './loadingButton.styles';

/**
 * @description - When use this button with customize color
 * please make sure the change the css variable btn-Color to match the color
 * between the button and the loading indicator
 */
const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  ({ children, loading = false, spinnerWidth = '24', ...props }, ref) => {
    return (
      <StyledButton {...props} disabled={props.disabled || loading} ref={ref}>
        {children}
        {loading && (
          <LoadingIndicatorBox>
            <RotatingLines
              strokeColor='#ffffff'
              strokeWidth='5'
              animationDuration='0.75'
              width={spinnerWidth}
              visible
            />
          </LoadingIndicatorBox>
        )}
      </StyledButton>
    );
  }
);

export default LoadingButton;
